import { Button, BackTop, Divider, Form, Input } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

export default function Step4({ ...props }) {
    const { setStep4, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep4(true);
                props.nextStep();
            })
            .catch(() => {
                setStep4(false);
                props.nextStep();
            });
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'hrPurposeTitleTh',
                'hrPurposeTitleEn',
                'hrPurposeContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.hrReasonCollectedData
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep4(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Reason for collected data')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="hrReasonCollectedData"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'hrPurposeTitleTh',
                        'hrPurposeTitleEn',
                        'hrPurposeContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep4(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('PurposeofCollectPersonalData')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrPurposeTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัทฯ อาจอาศัยความยินยอมในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลทั่วไปและ/หรือข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านเพื่อวัตถุประสงค์ต่อไปนี้\n1) เพื่อการจัดการที่เกี่ยวข้องกับการสมัครงาน และ/หรือการจ้างงาน เช่น การบันทึกข้อมูลที่เก็บรวบรวมจากผู้สมัครงานในฐานะที่เป็นส่วนหนึ่งของกระบวนการสมัครงาน การยืนยันตัวตนและตรวจสอบประวัติ การประเมินความเหมาะสมและคุณสมบัติของผู้สมัครงานการตัดสินใจจ้างงาน การเข้าทำสัญญาจ้างงานหรือสัญญาบริการ การจัดทำใบอนุญาตทำงานและเอกสารสำหรับการจ้างงาน และ/หรือการกำหนดเงินเดือน สวัสดิการและข้อมูลสัญญาพื้นฐานอื่น ๆ ในตำแหน่งใดตำแหน่งหนึ่ง\n2) เพื่อการติดต่อสื่อสาร เช่น การติดต่อสื่อสารที่เกี่ยวกับการสัมภาษณ์หรืองานกิจกรรมของท่าน การจัดส่งเอกสาร เพื่อติดต่อบุคคลอ้างอิงของท่านในกรณีจำเป็นและฉุกเฉิน และ/หรือเพื่อประชาสัมพันธ์ข่าวสารและเชิญเข้าร่วมกิจกรรมต่าง ๆ`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrPurposeContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrPurposeTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`We collect, use and/or disclose Personal Data for the following purposes:\n1) To manage job application and/or employment: such as, compilation of data from job applicant as part of the job application process, verification and background check, assessment of suitability and qualifications of job applicant, employment decision making, entering into employment agreement or service agreement, the preparation of work permit and employment document, and/or determination of salary, welfare, and other basic contractual informationin any particular position\n2) To contact and communicate: such as, to contact and communicate relating to your interview or activity, document delivery, to contact your emergency contact when necessary, and/or to publish news and invitation to events`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrPurposeContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    hrReasonCollectedDataId: null,
    hrPurposeTitleTh: 'วัตถุประสงค์ในการเก็บรวบรวมใช้เปิดเผยข้อมูลส่วนบุคคล',
    hrPurposeTitleEn: 'Purpose of collect, use or disclose Personal Data',
    hrPurposeContentTh: '',
    hrPurposeContentEn: '',
    hrPurposeIsDisplay: false,
};
